export var PreallocationSearchType;
(function (PreallocationSearchType) {
    PreallocationSearchType["INCLUDE_DESCRIPTION"] = "INCLUDE_DESCRIPTION";
})(PreallocationSearchType || (PreallocationSearchType = {}));
